import { PayloadAction } from '@reduxjs/toolkit';
import { StatusLoading } from 'common/constants/statusLoading';

import { IState } from '../types/state';

const action = (state: IState, payloadAction: PayloadAction<StatusLoading>) => {
  state.catalogs.statusLoading = payloadAction.payload;
};

export default action;
